import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { validate } from "./Schema";
import SingUpWihGoggle from "../SignUp/SingUpWihGoggle";
import { LoginApi } from "../../../Api/Register";
import { useDispatch, useSelector } from "react-redux";
import { Font } from "../../../utils/Font";

const SignIn = () => {
  const dispatch = useDispatch();
  const { currentUser, loginInLoading, loginInError, isGettingUser } =
    useSelector((state) => state.User);

  useEffect(() => {
    if (loginInError) {
      console.log("err", loginInError);
    }
    if (currentUser) {
      console.log("success", currentUser);
    }
  }, [loginInLoading, loginInError]);

  const onSubmit = (values, action) => {
    console.log(values);
    LoginApi(dispatch, values);
  };

  const {
    values,
    handleChange,
    touched,
    errors,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormik({
    initialValues: {
      password: "",
      email: "",
    },
    validationSchema: validate,
    onSubmit,
  });

  return (
    <div className="flex justify-center w-full">
      <div className="container sm:mt-40 mt-24 my-auto max-w-md border-2 border-gray-200 p-3 bg-white rounded-2xl w-full md:w-[500px]">
        <div className="text-center my-3">
          {/* <h1 className="text-3xl font-semibold text-indigo-400 font-workSans">
            Login
          </h1> */}
          <Font title=" Login" />
        </div>
        <div className="m-6">
          <form className="mb-4" onSubmit={handleSubmit} method="post">
            {/* importing sing up with google button */}
            <SingUpWihGoggle />

            <div className="text-sm text-gray-600 dark:text-gray-400 text-center uppercase my-2 font-semibold font-workSans">
              or
            </div>

            {/* email */}
            <div className="mb-3">
              <input
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                type="email"
                name="email"
                id="email"
                placeholder="Your email address"
                className={`w-full px-3 py-2 placeholder-gray-500 border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500 rounded-full bg-white border-none
                ${errors.email && touched.email ? "ring-2 ring-red-600 " : null}
                  ${
                    touched.email && !errors.email
                      ? "ring-2 ring-[#4FF072]"
                      : null
                  }
                  `}
              />
              {errors?.email && touched.email && (
                <small className="text-red-500">{errors.email}</small>
              )}
            </div>

            {/* password */}
            <div className="mb-3">
              <div className="flex justify-between mb-2"></div>
              <input
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                type="password"
                name="password"
                id="password"
                placeholder="Your password"
                autoComplete="on"
                className={`w-full px-3 py-2 placeholder-gray-500 border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500 rounded-full bg-white border-none
                    ${
                      errors.password && touched.password
                        ? "ring-2 ring-red-600"
                        : null
                    }
                  ${
                    touched.password && !errors.password
                      ? "ring-2 ring-[#4FF072]"
                      : null
                  }  
                  `}
              />
              {errors?.password && touched.password && (
                <small className="text-red-500">{errors.password}</small>
              )}
            </div>

            <div className="mb-2">
              <button
                disabled={loginInLoading || isGettingUser}
                type="submit"
                className="w-full px-3 py-2 text-white bg-indigo-600 hover:bg-indigo-600 focus:outline-none duration-100 ease-in-out rounded-3xl hover:shadow-lg"
              >
                {loginInLoading || isGettingUser ? "loading..." : "Signin"}
              </button>
            </div>

            {loginInError ? (
              <p className="text-center text-red-500 my-2">
                {loginInError.message}
              </p>
            ) : null}

            <div className="mb-2">
              <button
                type="button"
                className="w-full px-3 py-2 text-black border border-indigo-600 hover:bg-indigo-600 focus:outline-none duration-100 ease-in-out rounded-3xl hover:shadow-lg"
              >
                Forgoten password
              </button>
            </div>

            <div className="text-sm text-center text-gray-400 capitalize mt-2">
              have an account already?
              <Link
                to="/signUp"
                className="font-semibold text-indigo-500 focus:text-indigo-600 focus:outline-none focus:underline"
              >
                Register
              </Link>
              .
            </div>
          </form>
          {/* <div className="flex flex-row justify-center mb-8">
                <span className="absolute bg-white px-4 text-gray-500">
                  or sign-in with
                </span>
                <div className="w-full bg-gray-200 mt-3 h-px"></div>
              </div> */}
        </div>
      </div>
    </div>
  );
};

export default SignIn;
